import { useCallback } from 'react'

import { useAppDispatch } from '@/hooks'
import { StructureDto } from '@/rtkApi/mddApiSliceGenerated'
import { initMapping } from '@/store/modules/mapping/actions'
import { initReadMapping } from '@/store/modules/readMapping/actions'
import { initView } from '@/store/modules/view/actions'
import { initWriteMapping } from '@/store/modules/writeMapping/actions'

export const useStructureRefresh = () => {
	const dispatch = useAppDispatch()

	return useCallback(
		async (node: StructureDto) => {
			const nodeType = node.type

			if (nodeType === 'MAPPING_READ') {
				await dispatch(
					initReadMapping({ nodeId: node.id, editMode: true, force: true }),
				)
			} else if (nodeType === 'MAPPING_WRITE') {
				await dispatch(
					initWriteMapping({ nodeId: node.id, editMode: true, force: true }),
				)
			} else if (nodeType === 'VIEW') {
				await dispatch(
					initView({ nodeId: node.id, editMode: true, force: true }),
				)
			} else {
				await dispatch(
					initMapping({ nodeId: node.id, editMode: true, force: true }),
				)
			}
		},
		[dispatch],
	)
}

